import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { classNames } from './../../../utils/styles'

import Labelled from '../Labelled'

import styles from './TextField.scss'

export default class TextField extends PureComponent {
  static propTypes = {
    id: PropTypes.string,
    value: PropTypes.any,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    autoFocus: PropTypes.bool,
    type: PropTypes.string,
    name: PropTypes.string,
    error: PropTypes.any,
    multiline: PropTypes.bool,
    label: PropTypes.string,
    labelHidden: PropTypes.bool,
    helpText: PropTypes.any,
    prefix: PropTypes.any,
    suffix: PropTypes.any,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onMouseUp: PropTypes.func,
    onKeyDown: PropTypes.func,
    min: PropTypes.any,
    max: PropTypes.any,
    minLength: PropTypes.any,
    maxLength: PropTypes.any,
    spellCheck: PropTypes.bool,
    pattern: PropTypes.string,
    autocompelete: PropTypes.string,
    floatIcon: PropTypes.any,
    floatIconClick: PropTypes.func,
    innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string]),
  }
  constructor(props) {
    super(props)

    this.state = {
      focus: false,
      id: props.id,
    }

    this.inputRef = this.props.innerRef ? this.props.innerRef : React.createRef()
  }

  render() {
    const {
      id = this.state.id,
      className,
      value = '',
      placeholder,
      disabled,
      readOnly,
      autoFocus,
      type,
      name,
      error,
      multiline,
      label,
      labelHidden,
      helpText,
      prefix,
      suffix,
      onChange,
      onFocus,
      onBlur,
      onKeyDown,
      onMouseUp,
      min,
      max,
      minLength,
      maxLength,
      spellCheck,
      pattern,
      floatIcon,
      floatIconClick,
      autocompelete,
    } = this.props

    const classes = classNames(
      styles.TextField,
      Boolean(value) && styles.hasValue,
      disabled && styles.disabled,
      readOnly && styles.readOnly,
      error && styles.error,
      multiline && styles.multiline,
      this.state.focus && styles.focus,
    )

    const prefixMarkup = prefix ? (
      <div className={styles.Prefix} id={`${id}Prefix`}>
        {prefix}
      </div>
    ) : null

    const suffixMarkup = suffix ? (
      <div className={styles.Suffix} id={`${id}Suffix`}>
        {suffix}
      </div>
    ) : null

    const onFloatClick = () => {
      this.inputRef.current.focus()
      if (floatIconClick) {
        floatIconClick()
      }
    }

    const floatMarkup = floatIcon ? (
      <div className={classNames(styles.Suffix, styles.floatMarkup)} onClick={onFloatClick} id={`${id}Float`}>
        {floatIcon}
      </div>
    ) : null

    const input = React.createElement(multiline ? 'textarea' : 'input', {
      ref: this.inputRef,
      name,
      id,
      disabled,
      readOnly,
      autoFocus,
      value,
      placeholder,
      onFocus,
      onBlur,
      onKeyDown,
      onChange,
      className: className
        ? classNames(className, styles.Input, multiline && styles.MultilineInput)
        : classNames(styles.Input, multiline && styles.MultilineInput),
      min,
      max,
      minLength,
      maxLength,
      spellCheck,
      pattern,
      type,
      onMouseUp,
      autocompelete,
    })

    return (
      <Labelled label={label} id={id} error={error} labelHidden={labelHidden} helpText={helpText}>
        <div className={classes}>
          {prefixMarkup}
          {input}
          {floatMarkup}
          {suffixMarkup}
          <div className={styles.Backdrop} />
        </div>
      </Labelled>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/TextField/index.js